window.RESIN_DATA = {
  "resins": [
    {
      "name": "Anycubic Tough Resin v2.0",
      "link": "https://amzn.to/4bl6v8M",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#000000  |Black",
        "#ffe     |Clear"
      ],
      "description": "Combines softness and strength, resisting bending, flexing, and compression while preventing chipping, cracking, and stress marks from cyclic movements. It offers high rigidity and impact resistance, making crash-proof parts that withstand mechanical pressure. The resin ensures high precision, smooth surfaces, clear details, and low shrinkage; shake well before use to mix components and avoid uneven coloring. Compatible with all LCD 3D printers, optimized for 365nm-405nm wavelengths, it is ideal for industrial spare parts, building models, DIY projects, and high-strength applications.",
      "price": "25.99",
      "tensileStrength": "35-45",
      "flexureStrength": "50-60",
      "elongationAtBreak": "30-50",
      "impactResistance": "50-60",
      "hardness": "76",
      "uvWavelength": "365 - 405",
      "density": "1.1 - 1.15",
      "viscosity": "150-250",
      "shrinkage": "",
      "printingEnvironmentTemp": "25-30",
      "flexuralModulus": "900-1200",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": "25"
    },
    {
      "name": "Anycubic Standard Resin",
      "link": "https://amzn.to/4djDUCz",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#bbc0cc  |Grey",
        "#68757b  |HD Grey",
        "#f0c2ac  |Light Beige",
        "#32ac14  |Translucent Green",
        "#fff     |White"
      ],
      "description": "Classic formula, excels in print accuracy, hardness, and flowability. Ideal for Beginners.",
      "price": "17.99",
      "tensileStrength": "35-45",
      "flexureStrength": "40-50",
      "elongationAtBreak": "7-14",
      "impactResistance": "",
      "hardness": "82-85",
      "uvWavelength": "365-405",
      "density": "1.13",
      "viscosity": "250-300",
      "shrinkage": "4.5-5.5",
      "printingEnvironmentTemp": "25-30",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": "25"
    },
    {
      "name": "Anycubic UV Tough Resin",
      "link": "https://amzn.to/3QxXi56",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#bbc0cc  |Grey",
        "#32ac14  |Translucent Green",
        "#fff     |White"
      ],
      "description": "Balances flexibility and toughness, strong resistance to compression, stretching, and bending",
      "price": "25.99",
      "tensileStrength": "25-40",
      "flexureStrength": "40-50",
      "elongationAtBreak": "35-50",
      "impactResistance": "",
      "hardness": "74-78",
      "uvWavelength": "365-405",
      "density": "1.05-1.15",
      "viscosity": "150-250",
      "shrinkage": "5.1-6.2",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic Plant-based UV",
      "link": "https://amzn.to/4br0GGP",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#bbc0cc  |Grey",
        "#32ac14  |Translucent Green",
        "#fff     |White"
      ],
      "description": "Soybean Oil Formula. Low odor.",
      "price": "9.99",
      "tensileStrength": "35-45",
      "flexureStrength": "40-50",
      "elongationAtBreak": "8-15",
      "impactResistance": "",
      "hardness": "82-85",
      "uvWavelength": "365-405",
      "density": "1.12-1.20",
      "viscosity": "250-300",
      "shrinkage": "3.8-4.5",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic DLP Craftsman",
      "link": "https://amzn.to/44mWfdT",
      "colors": [
        "#f0c2ab  |Beige",
        "#000000  |Black",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Incorporates nano-scale microcrystalline ceramic powder for improved light scattering, ideal for high performance details",
      "price": "38.99",
      "tensileStrength": "32-43",
      "flexureStrength": "50-70",
      "elongationAtBreak": "11-14",
      "impactResistance": "",
      "hardness": "80-83",
      "uvWavelength": "365-405",
      "density": "1.15-1.20",
      "viscosity": "200-300",
      "shrinkage": "4.2-5.5",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1200-1600",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic Water-Wash Resin+",
      "link": "https://amzn.to/4b9ai9s",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#bbc0cc  |Grey",
        "#68757b  |HD Grey",
        "#fff     |White"
      ],
      "description": "Formulated with hydrophilic components, easier to clean with water, increases printing speed. Easy to Clean Up.",
      "price": "19.99",
      "tensileStrength": "40-50",
      "flexureStrength": "45-60",
      "elongationAtBreak": "8-18",
      "impactResistance": "",
      "hardness": "80-85",
      "uvWavelength": "365-405",
      "density": "1.15-1.20",
      "viscosity": "200-300",
      "shrinkage": "4.2-5.5",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic Standard Resin+",
      "link": "https://amzn.to/3JQ8tSK",
      "colors": [
        "#000000  |Black",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Enhanced molding accuracy, suitable for delicate and precise printing results",
      "price": "17.99",
      "tensileStrength": "35",
      "flexureStrength": "32",
      "elongationAtBreak": "18",
      "impactResistance": "",
      "hardness": "82",
      "uvWavelength": "365-405",
      "density": "1.15",
      "viscosity": "200",
      "shrinkage": "3.72-4.24",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "950",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic ABS-Like Resin+",
      "link": "https://store.anycubic.com/products/anycubic-abs-like-resin",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#bbc0cc  |Grey",
        "#32ac14  |Translucent Green",
        "#fff     |White"
      ],
      "description": "High Strength. Excellent Toughness",
      "price": "32",
      "tensileStrength": "32",
      "flexureStrength": "38",
      "elongationAtBreak": "25",
      "impactResistance": "",
      "hardness": "81.3",
      "uvWavelength": "365-405",
      "density": "1.05-1.25",
      "viscosity": "220",
      "shrinkage": "3.72-4.24",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1150",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic ABS-Like Resin V2",
      "link": "https://amzn.to/4dqIG0Y",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#000000  |Black",
        "#ffe     |Clear"
      ],
      "description": "Low viscosity, high toughness, strength, and impact resistance, suitable for structural components, tools. Water Washable",
      "price": "25.99",
      "tensileStrength": "35-45",
      "flexureStrength": "40-50",
      "elongationAtBreak": "30-40",
      "impactResistance": "",
      "hardness": "80-85",
      "uvWavelength": "365-405",
      "density": "1.1-1.2",
      "viscosity": "180-200",
      "shrinkage": "4.3-5.6",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic ABS-Like Pro 2",
      "link": "https://amzn.to/3UHKRG4",
      "colors": [
        "#f0c2ab  |Beige",
        "#000000  |Black",
        "#ffe     |Clear",
        "#bbc0cc  |Grey",
        "#32ac14  |Translucent Green",
        "#fff     |White"
      ],
      "description": "Enhanced Strength and Enhanced Toughness",
      "price": "19.99",
      "tensileStrength": "35-45",
      "flexureStrength": "40-45",
      "elongationAtBreak": "35-40",
      "impactResistance": "",
      "hardness": "82-84",
      "uvWavelength": "365-405",
      "density": "1.05-1.25",
      "viscosity": "300-400",
      "shrinkage": "4.3-5.6",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic ABS-Like Pro",
      "link": "https://store.anycubic.com/products/anycubic-abs-like-resin-pro?_pos=1&_sid=27b5842eb&_ss=r",
      "colors": [
        "#000000  |Black",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Enhanced Strength and Enhanced Toughness",
      "price": "44",
      "tensileStrength": "45-70",
      "flexureStrength": "70-100",
      "elongationAtBreak": "20-30",
      "impactResistance": "",
      "hardness": "86-88",
      "uvWavelength": "365-405",
      "density": "1.05-1.25",
      "viscosity": "400-500",
      "shrinkage": "3.4-4.0",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1800-2200",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic High Clear",
      "link": "https://amzn.to/4b5xLbx",
      "colors": [
        "#ffe     |Clear"
      ],
      "description": "Produces excellent transparent objects, ideal for prototypes, gifts, or jewelry.",
      "price": "31.99",
      "tensileStrength": "28",
      "flexureStrength": "",
      "elongationAtBreak": "14.60",
      "impactResistance": "",
      "hardness": "78",
      "uvWavelength": "365-405",
      "density": "1.05-1.25",
      "viscosity": "266",
      "shrinkage": "3.72-4.24",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic Plant-Based Resin+",
      "link": "https://store.anycubic.com/products/anycubic-plant-based-uv-resin",
      "colors": [
        "#000000  |Black",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Resilient and eco-friendly, upgraded performance, light odor, accurate and stable",
      "price": "44",
      "tensileStrength": "35-55",
      "flexureStrength": "40-60",
      "elongationAtBreak": "18-20",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "365-405",
      "density": "",
      "viscosity": "300-500",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic High Speed Resin",
      "link": "https://amzn.to/3WttcU3",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#bbc0cc  |Grey",
        "#68757b  |HD Grey",
        "#f0c2ac  |Light Beige",
        "#32ac14  |Translucent Green",
        "#fff     |White"
      ],
      "description": "Print Up to 3X Faster, Special for Anycubic Photon Mono M5s/M5s Pro, Apply for Large-Size 3D Printing Models, Low Viscosity and Stable",
      "price": "36.99",
      "tensileStrength": "45-60",
      "flexureStrength": "60-85",
      "elongationAtBreak": "6-9",
      "impactResistance": "",
      "hardness": "90-93",
      "uvWavelength": "365-405",
      "density": "1.15",
      "viscosity": "55-65",
      "shrinkage": "5.1-6.2",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1800-3000",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic Standard Resin v2",
      "link": "https://amzn.to/4b0bxrl",
      "colors": [
        "#f0c2ab  |Beige",
        "#000000  |Black",
        "#ffe     |Clear",
        "#bbc0cc  |Grey",
        "#68757b  |HD Grey",
        "#32ac14  |Translucent Green",
        "#fff     |White"
      ],
      "description": "High Strength. Low Odor.",
      "price": "21.99",
      "tensileStrength": "35-45",
      "flexureStrength": "40-50",
      "elongationAtBreak": "25-30",
      "impactResistance": "",
      "hardness": "80-83",
      "uvWavelength": "365-405",
      "density": "1.05-1.25",
      "viscosity": "250-350",
      "shrinkage": "4.3-5.6",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Anycubic Tough Resin Ultra",
      "link": "https://amzn.to/44xigXy",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Impact Resistance, Suitable as an Additive",
      "price": "42.99",
      "tensileStrength": "20-28",
      "flexureStrength": "15-25",
      "elongationAtBreak": "70-80",
      "impactResistance": "",
      "hardness": "71-75",
      "uvWavelength": "",
      "density": "1.05-1.25",
      "viscosity": "300-400",
      "shrinkage": "5.1-6.2",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Elegoo Water Washable Resin",
      "link": "https://amzn.to/3JNkDvL",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#46cfb2  |8K Vanilla",
        "#f0c2ab  |Beige",
        "#000000  |Black",
        "#ffe     |Clear",
        "#95f5f4  |Clear Blue",
        "#32ac15  |Clear Green",
        "#d94b2d  |Clear Red",
        "#bbc0cc  |Grey",
        "#46cfb1  |Mint Green",
        "#1d263f  |Smokey black",
        "#fff     |White"
      ],
      "description": "Easy to clean, easy to use, High Precision and Low Shrinkage, Fast Curing and Great Stability, Low odor, non-irritating",
      "price": "21.83",
      "tensileStrength": "30-52",
      "flexureStrength": "40-70",
      "elongationAtBreak": "13.42-16.40",
      "impactResistance": "",
      "hardness": "80-85",
      "uvWavelength": "",
      "density": "1.05-1.25",
      "viscosity": "100-350",
      "shrinkage": "3.72-4.24",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "327.96",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Elegoo Standard Resin",
      "link": "https://amzn.to/3UYfrLH",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#b5857b  |8K Red Clay",
        "#46cfb2  |8K Vanilla",
        "#cccdcf  |8K White Smoke",
        "#f0c2ab  |Beige",
        "#000000  |Black",
        "#67c4de  |Blue",
        "#ffe     |Clear",
        "#d94b2d  |Clear Red",
        "#bbc0cc  |Grey",
        "#9594b4  |Grey to Purple",
        "#b14a41  |Maroon",
        "#5f649b  |Medium Slate BLue",
        "#906297  |Orchid",
        "#674c5f  |Slate BLue",
        "#32ac14  |Translucent Green",
        "#fff     |White",
        "#fcc262  |Yellow"
      ],
      "description": "Low Shrinkage and High Precision, Fast Curing and Great Stability, Bright and Stunning Colors",
      "price": "21.24",
      "tensileStrength": "35.15-42.97",
      "flexureStrength": "44.04-53.82",
      "elongationAtBreak": "8.46-10.34",
      "impactResistance": " 72-88",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "484.56-592.24",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Elegoo ABS-Like Resin",
      "link": "https://amzn.to/4aLp2dt",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#46cfb2  |8K Vanilla",
        "#ffe     |Clear",
        "#95f5f4  |Clear Blue",
        "#d94b2d  |Clear Red"
      ],
      "description": "High Toughness, Low Shrinkage and High Precision, Fast Curing and Great Stability, Bright and Stunning Colors",
      "price": "27.98",
      "tensileStrength": "35-43",
      "flexureStrength": "",
      "elongationAtBreak": "14",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Elegoo 8K Water Washable Resin",
      "link": "https://amzn.to/4akPxWX",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#46cfb2  |8K Vanilla",
        "#cccdcf  |8K White Smoke",
        "#000000  |Black",
        "#ffe     |Clear",
        "#95f5f4  |Clear Blue",
        "#32ac15  |Clear Green",
        "#d94b2d  |Clear Red",
        "#68757b  |HD Grey",
        "#f0c2ac  |Light Beige",
        "#fcc262  |Yellow"
      ],
      "description": "Low Shrinkage and High Precision, Fast Curing and Great Stability, Bright and Stunning Colors",
      "price": "28.99",
      "tensileStrength": "30-52",
      "flexureStrength": "40-70",
      "elongationAtBreak": "9.00-11.00",
      "impactResistance": "61.20-74.80",
      "hardness": "80-85",
      "uvWavelength": "",
      "density": "1.05-1.25",
      "viscosity": "100-350",
      "shrinkage": "3.72-4.24",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "684.48-836.58",
      "youngsModulus": "294.93-360.47",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Elegoo Plant-Based Resin",
      "link": "https://amzn.to/4bKoMwt",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#000000  |Black",
        "#ffe     |Clear",
        "#32ac15  |Clear Green"
      ],
      "description": "Safe and no irriation, Great toughness and high precision",
      "price": "19.19",
      "tensileStrength": "24-30",
      "flexureStrength": "18-22",
      "elongationAtBreak": "19-23",
      "impactResistance": "52-63",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "478-584",
      "youngsModulus": "295-361",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Elegoo 8K Standard Resin",
      "link": "https://amzn.to/3UNCxDs",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#46cfb2  |8K Vanilla",
        "#cccdcf  |8K White Smoke",
        "#000000  |Black",
        "#67c4de  |Blue",
        "#ffe     |Clear",
        "#32ac15  |Clear Green",
        "#d94b2d  |Clear Red",
        "#9594b4  |Grey to Purple",
        "#f0c2ac  |Light Beige",
        "#b14a41  |Maroon",
        "#906297  |Orchid",
        "#674c5f  |Slate BLue",
        "#fcc262  |Yellow"
      ],
      "description": "Low Shrinkage and High Precision, Low Shrinkage and High Precision, Bright and Stunning Colors, Non-Brittle and Less Odor",
      "price": "16.39",
      "tensileStrength": "35.15-42.97",
      "flexureStrength": "44.04-53.82",
      "elongationAtBreak": "8.46-10.34",
      "impactResistance": "72.00-88.00",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1271.52-1554.08",
      "youngsModulus": "484.56-592.24",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Elegoo RAPID Standard Resin",
      "link": "https://amzn.to/4biZqG7",
      "colors": [
        "#bbc0cd  |8K Grey"
      ],
      "description": "Fast Photocuring Ability, Smooth and Efficient Printing Experience, High Precision Resin, Good Prototyping Effect, High Compatibility",
      "price": "21.24",
      "tensileStrength": "33.81-41.33",
      "flexureStrength": "38.25-46.75",
      "elongationAtBreak": "9.95-12.16",
      "impactResistance": "17.91-21.89",
      "hardness": "81-88",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "985.18-1204.10",
      "youngsModulus": "402.60-492.06",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Elegoo ABS-Like Resin 2",
      "link": "https://amzn.to/3x4Ptx9",
      "colors": [
        "#ffe     |Clear"
      ],
      "description": "Less Odor, Low Shrinkage, Higher Precision, Better Scratch Resistance, High Toughness",
      "price": "41.99",
      "tensileStrength": "32.22-39.38",
      "flexureStrength": "28.93-35.35",
      "elongationAtBreak": "35.93-43.91",
      "impactResistance": "58.50-71.50",
      "hardness": "80-88",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "864.61-1056.75",
      "youngsModulus": "406.75-497.15",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "AmeraLabs AMD-3",
      "link": "https://amzn.to/3VpRnl8",
      "colors": [
        "#bbc0cc  |Grey"
      ],
      "description": "For 4K/8K/12K LCD LED DLP printers with 405nm UV-curing. It offers high resolution and detailed accuracy, ideal for scale models and prototyping. This fast resin prints 2-3 times quicker than others on most SLA printers and captures fine details like hair and wrinkles. It is hard and stiff, with low odor, low skin irritation, and minimal shrinkage, making it perfect for home use and stable in moist or corrosive environments.",
      "price": "65",
      "tensileStrength": "65",
      "flexureStrength": "83.6",
      "elongationAtBreak": "3.3",
      "impactResistance": "",
      "hardness": "85",
      "uvWavelength": "365-420",
      "density": "",
      "viscosity": "390",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "2740",
      "youngsModulus": "3450",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Fast ABS-Like Resin",
      "link": "https://amzn.to/3UGURyg",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#46cfb2  |8K Vanilla",
        "#ffe     |Clear"
      ],
      "description": "Fast Printing and Curing, Low Odor and Easy to Clean, Great Resolution and Surface Finish, High Precision and Low Shrinkage",
      "price": "26.63",
      "tensileStrength": "33",
      "flexureStrength": "68 ",
      "elongationAtBreak": "7",
      "impactResistance": "25",
      "hardness": "75",
      "uvWavelength": "395-405",
      "density": "",
      "viscosity": "100 ",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "1100",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Blu Tough",
      "link": "https://amzn.to/3wSTl44",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#79d9e0  |Emerald Blue"
      ],
      "description": "Good balance between hardness and impact resistance. Strong and Not Brittle, High Precision and Resolution, Works Great As Additive",
      "price": "49.95",
      "tensileStrength": "50",
      "flexureStrength": "",
      "elongationAtBreak": "32",
      "impactResistance": "50",
      "hardness": "85",
      "uvWavelength": "395-405",
      "density": "1.15",
      "viscosity": "800",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1750",
      "youngsModulus": "1800",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Blu Nylon",
      "link": "https://amzn.to/4bPdW8a",
      "colors": [
        "#000000  |Black"
      ],
      "description": "High hardness and robustness make it suitable for various parts and tool making. It is also bio-compatible as certified under ISO 10993-10. Higher impact resistance than normal Blu.",
      "price": "49.95",
      "tensileStrength": "65",
      "flexureStrength": "",
      "elongationAtBreak": "40",
      "impactResistance": "53",
      "hardness": "80",
      "uvWavelength": "395-405",
      "density": "1.15",
      "viscosity": "750",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1900",
      "youngsModulus": "2000",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Blu Nylon Mecha",
      "link": "https://amzn.to/4byUCMT",
      "colors": [
        "#ffe     |Clear"
      ],
      "description": "A tough engineering resin that has excellent mechanical properties. High hardness and robustness make it suitable for various parts and tool making. It is also bio-compatible as certified under ISO 10993-10. Higher impact and wear resistance than normal Blu. Applications: Gear and joint parts, Engineering Prototypes, Mechanical Aids, Fixtures and Jigs, Medical Devices, Load-bearing parts",
      "price": "49.95",
      "tensileStrength": "63",
      "flexureStrength": "",
      "elongationAtBreak": "37",
      "impactResistance": "50",
      "hardness": "82",
      "uvWavelength": "395-405",
      "density": "1.25",
      "viscosity": "1000",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1830",
      "youngsModulus": "1900",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Build Resin",
      "link": "https://amzn.to/3KetZRg",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#1d263f  |Smokey black"
      ],
      "description": "An affordable, easy to print and, non-brittle enginering resin ideal for prints that require high precision, no warping and tappable\nIt is an a good balance between hardness, resolution and a bit flexible to make it ideal for projects.",
      "price": "48.74",
      "tensileStrength": "33",
      "flexureStrength": "",
      "elongationAtBreak": "8",
      "impactResistance": "",
      "hardness": "73",
      "uvWavelength": "395-405",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "850",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Tenacious Clear and Obsidian Black",
      "link": "https://amzn.to/3wT6IBi",
      "colors": [
        "#ffe     |Clear",
        "#2b2a30  |Obsidian Black"
      ],
      "description": "Highly versatile and durable 3D printing resin that offers excellent impact resistance, flexibility, and toughness. Has a high polymer content, which contributes to its outstanding mechanical properties and adds significant toughness and durability to a part. Thin objects printed in Tenacious can be bent 180 degrees without shattering, while thicker objects show great strength and resilience, especially when printed thick. Can be mixed with other resins to increase the toughness of other resins.",
      "price": "48.74",
      "tensileStrength": "28",
      "flexureStrength": "",
      "elongationAtBreak": "70",
      "impactResistance": "",
      "hardness": "65",
      "uvWavelength": "395-405",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "800",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Tenacious Flex Black",
      "link": "https://amzn.to/4dUWVvd",
      "colors": [
        "#17161d  |Flex Black"
      ],
      "description": "The Shore Hardness of Tenacious Flex Black is 70A. It is softer than regular Tenacious and rebounds faster. It can quickly recover its shape after being subjected to external bending and compression pressure. Its high elasticity allows it to withstand greater impact.",
      "price": "48.74",
      "tensileStrength": "5",
      "flexureStrength": "",
      "elongationAtBreak": "\t140",
      "impactResistance": "",
      "hardness": "70",
      "uvWavelength": "395-405",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "100",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Sculpt High-Temp Resistant",
      "link": "https://amzn.to/3wID55P",
      "colors": [
        "#ffe     |Clear",
        "#1d2228  |Dark Grey",
        "#ece9e4  |Ultra White"
      ],
      "description": "Developed to be the go-to resin for model makers with high hardness, great surface finish, excellent resolution, and high-temperature resistance at 160C. Not only prints made with Sculpt is easy to get great looks with minimal post-processing effort. The hi-temp feature allows Sculpt to be used to make vulcanized rubber molds or to be printed as mold.",
      "price": "66",
      "tensileStrength": "35",
      "flexureStrength": "",
      "elongationAtBreak": "5",
      "impactResistance": "",
      "hardness": "90",
      "uvWavelength": "395-405",
      "density": "1.13",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "3500",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "180",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Simple Water Washable Resin",
      "link": "https://amzn.to/3KfmOsi",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#ffe     |Clear",
        "#1d263f  |Smokey black"
      ],
      "description": "Simple is an affordable easy to print and clean for general application resin ideal for model making like tabletop minis, and figurines.\nIt can be cleaned with 15% alcohol and is ideal for large format printer and new resin printer users",
      "price": "23.09",
      "tensileStrength": "25",
      "flexureStrength": "",
      "elongationAtBreak": "4",
      "impactResistance": "18",
      "hardness": "75",
      "uvWavelength": "395-405",
      "density": "",
      "viscosity": "110",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "650",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "60",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Easy - Plant-Based Resin",
      "link": "https://amzn.to/4bGTJSk",
      "colors": [
        "#bbc0cc  |Grey"
      ],
      "description": "Easy is a plant-based resin developed to be an affordable general application resin ideal for model making like tabletop minis, and figurines. It uses raw materials from renewable sources so it is easier on the environment. It is not a tough or engineering resin but can be mixed with Blu/Tenacious for more impact resistance.",
      "price": "19.59",
      "tensileStrength": "28",
      "flexureStrength": "",
      "elongationAtBreak": "3",
      "impactResistance": "",
      "hardness": "75",
      "uvWavelength": "395-405",
      "density": "",
      "viscosity": "225",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "700",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "52",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Craft Ultra-Clear",
      "link": "https://amzn.to/3wO8xj2",
      "colors": [
        "#ffe     |Clear"
      ],
      "description": "Craft – Clear resin is perfect for projects needing minimal yellowing and easy printing. This resin can be cured using UV light, sunlight, or even smartphone flashlights. When printing solid pieces, it is crucial to account for the process of bubble removal.",
      "price": "34.43",
      "tensileStrength": "38",
      "flexureStrength": "",
      "elongationAtBreak": "6",
      "impactResistance": "25",
      "hardness": "82",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "1200",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "75",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Craft Glow-in-The-Dark",
      "link": "https://amzn.to/4bujNQN",
      "colors": [
        "#00da9b  |Glow in the Dark"
      ],
      "description": "Heat Deflection Temperature: 65C The Craft – Glow In The Dark resin is perfect for projects that need the print to glow in the dark. This resin can be cured using UV light, sunlight, or even smartphone flashlights. The best printing conditions for Craft are temperatures above 25°C, as this enhances curing speed and reduces viscosity.",
      "price": "69.99",
      "tensileStrength": "43",
      "flexureStrength": "",
      "elongationAtBreak": "2.5",
      "impactResistance": "",
      "hardness": "84",
      "uvWavelength": "",
      "density": "",
      "viscosity": "330",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "950",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Cast - Castable",
      "link": "https://amzn.to/4dSaJ9S",
      "colors": [
        "#8640a9  |Purple"
      ],
      "description": "Heat Deflection Temperature: 50C. Designed for thicker designs and metal parts, offering easy burning and clean burnout. It delivers a smooth surface and high resolution, and is a 405nm UV-curing resin. This castable LCD UV-curing resin is easy to print and burn, making it ideal for creating jewelry and metal parts",
      "price": "40.47",
      "tensileStrength": "20",
      "flexureStrength": "",
      "elongationAtBreak": "5",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "300",
      "shrinkage": "6",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "600",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Cast - Castable",
      "link": "https://amzn.to/4bKNuws",
      "colors": [
        "#087cd0  |True Blue"
      ],
      "description": "Heat Deflection Temperature: 50C. Designed for thicker designs and metal parts, offering easy burning and clean burnout. It delivers a smooth surface and high resolution, and is a 405nm UV-curing resin. This castable LCD UV-curing resin is easy to print and burn, making it ideal for creating jewelry and metal parts",
      "price": "42.99",
      "tensileStrength": "20",
      "flexureStrength": "",
      "elongationAtBreak": "4",
      "impactResistance": "",
      "hardness": "65",
      "uvWavelength": "",
      "density": "",
      "viscosity": "300",
      "shrinkage": "6",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "600",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Siraya Tech Form Resin for SLA",
      "link": "https://siraya.tech/products/form-resin-for-sla-printers",
      "colors": [
        "#bbc0cd  |8K Grey"
      ],
      "description": "This resin is intended for use with laser printers. It is not suitable for LCD, MSLA, or low-power DLP printers. If you are using a Formlabs printer, select Grey V3 or V4. If you are using a Peopoly Moai, set the laser power to 58.",
      "price": "39.99",
      "tensileStrength": "42",
      "flexureStrength": "",
      "elongationAtBreak": "6",
      "impactResistance": "25",
      "hardness": "85",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "1250",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Aqua 8K",
      "link": "https://amzn.to/3KelxS7",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#bb8571  |Aqua Red Clay",
        "#f5f0f4  |Aqua Snow Grey",
        "#fbead0  |Aqua Vanilla"
      ],
      "description": "Phrozen Aqua Resins are engineered for low shrinkage and high precision, making them perfect for producing precise parts with minimal warpage and excellent dimensional stability. Optimized for use with 8K printers like the Sonic Mini 8K, Aqua-Gray 8K resin enables the creation of highly detailed and intricate 3D models. Versatile in application, this resin is suitable for precision model printing, complex prototyping, miniatures, and busts. Additionally, its low viscosity facilitates easy printing and post-processing, while emitting minimal fumes, ensuring a low-odor workspace.",
      "price": "44.19",
      "tensileStrength": "43",
      "flexureStrength": "",
      "elongationAtBreak": "8",
      "impactResistance": "28-31",
      "hardness": "82",
      "uvWavelength": "",
      "density": "",
      "viscosity": "280-380",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Aqua 4K",
      "link": "https://amzn.to/44TJDeo",
      "colors": [
        "#ddcbc1  |Aqua Ivory",
        "#bbc0cc  |Grey"
      ],
      "description": "Phrozen Aqua Series Resin offers low shrinkage, high precision, low warpage, and excellent dimensional stability for precise parts. Its low viscosity and minimal odor make it easy to print and post-process. Designed for 405nm LCD printers, it reduces forming time without compromising quality. Suitable for model printing and product prototyping, printed parts are hard and tough. Specifications: 1kg per bottle, 50 µm XY resolution, 30-100 µm layer height, clean with alcohol spray and air gun (avoid prolonged immersion).",
      "price": "39.59",
      "tensileStrength": "24",
      "flexureStrength": "",
      "elongationAtBreak": "13",
      "impactResistance": "28-31",
      "hardness": "80",
      "uvWavelength": "",
      "density": "",
      "viscosity": "210-310",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Phrozen Aqua Hyperfine",
      "link": "https://amzn.to/3URnB7z",
      "colors": [
        "#32383d  |Graphite",
        "#295466  |Phrozen Blue",
        "#535e44  |Phrozen Green",
        "#4f496f  |Phrozen Purple",
        "#362f34  |Phrozen Red"
      ],
      "description": "Crafted for 8K printers, ensuring superior clarity and detail for ultra-high-resolution printing. It delivers exceptional precision for intricate textures and high-resolution projects. Available in five vibrant colors, it offers endless creative possibilities and allows effortless color mixing, eliminating the need for post-print painting. With low viscosity and minimal odor, it provides a seamless and pleasant printing experience, ideal for both hobbyists and professionals. User guide: https://cdn.shopify.com/s/files/1/0436/6965/1618/files/User_Guide_Hyperfine_Resin_EN.pdf?v=1706079047\n",
      "price": "56.39",
      "tensileStrength": "32.3–38.7",
      "flexureStrength": "",
      "elongationAtBreak": "2.9–6.6",
      "impactResistance": "36-45",
      "hardness": "75–86",
      "uvWavelength": "",
      "density": "1.15",
      "viscosity": "300–350",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "1614–2104",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "57.7–61.7",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Onyx Impact Plus",
      "link": "https://amzn.to/3QXePDW",
      "colors": [
        "#000000  |Black"
      ],
      "description": "HTD at 0.45 MPa: 52 °C. In collaboration with Loctite, Phrozen ONYX Impact Plus offers 5x greater impact resistance, ideal for tough daily projects and engineering applications.",
      "price": "110.19",
      "tensileStrength": "37",
      "flexureStrength": "",
      "elongationAtBreak": "98",
      "impactResistance": "54",
      "hardness": "72",
      "uvWavelength": "",
      "density": "1.05",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "977",
      "youngsModulus": "1128-1222",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Water-Washable",
      "link": "https://amzn.to/3QXq6US",
      "colors": [
        "#bbc0cd  |8K Grey",
        "#000000  |Black"
      ],
      "description": "Phrozen Water-Washable Resin is easily cleaned with water but cure waste water before disposal. It features low viscosity and odor for easy printing and post-processing. Designed for 405nm LCD printers, it offers fast printing without quality loss. The printed parts are tough and non-brittle, ideal for models and prototyping.",
      "price": "40.49",
      "tensileStrength": "12",
      "flexureStrength": "",
      "elongationAtBreak": "24",
      "impactResistance": "3.04",
      "hardness": "77",
      "uvWavelength": "405",
      "density": "1.10",
      "viscosity": "125",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "110",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Aqua",
      "link": "https://amzn.to/3yxFukk",
      "colors": [
        "#67c4de  |Blue",
        "#ffe     |Clear",
        "#46cfb1  |Mint Green"
      ],
      "description": "Phrozen Aqua Series Resin offers low shrinkage and high precision, with excellent dimensional stability and minimal warpage for precise parts. Its low viscosity ensures easy printing and post-processing, while emitting minimal odor for a pleasant work environment. Tailored for 405nm LCD printers, Aqua Clear Rapid Resin significantly reduces printing time without compromising quality. The resin produces hard, tough printed parts, ideal for various applications, including model printing and product prototyping.",
      "price": "34.59",
      "tensileStrength": "22",
      "flexureStrength": "29",
      "elongationAtBreak": "14",
      "impactResistance": "1.81K",
      "hardness": "74",
      "uvWavelength": "",
      "density": "1.11",
      "viscosity": "500-1000",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "701",
      "youngsModulus": "735",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen High Temp",
      "link": "https://amzn.to/4dTLIel",
      "colors": [
        "#32383d  |Graphite"
      ],
      "description": "This high-quality resin offers excellent heat resistance and mechanical strength, producing durable and reliable prints. With moderate viscosity and low odor, it ensures consistent, high-quality results and is easy to work with. Engineered for environmental stability, it maintains high print quality. Designed for optimal performance, it offers a high success rate and is easy to clean. Ideal for prototyping, it delivers exceptional results for toy and product design applications.",
      "price": "36.29",
      "tensileStrength": "25",
      "flexureStrength": "",
      "elongationAtBreak": "20",
      "impactResistance": "6.31K",
      "hardness": "79",
      "uvWavelength": "",
      "density": "1.1",
      "viscosity": "180-280",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "900",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Onyx Rigid Pro410",
      "link": "https://amzn.to/3yqlOyE",
      "colors": [
        "#000000  |Black"
      ],
      "description": "Ensures firm, distortion-free 3D models that are both strong and precise, allowing for fine details. Ideal for creative projects, it can be used to make pen holders, paint holders, cardholders, and spice racks. Its high holding strength is perfect for DIY clothes hangers, grocery bag holders, guitar hangers, and wall hooks. Additionally, it produces durable, long-lasting miniatures for tabletop gaming.",
      "price": "76.59",
      "tensileStrength": "43",
      "flexureStrength": "",
      "elongationAtBreak": "5",
      "impactResistance": "25",
      "hardness": "78",
      "uvWavelength": "",
      "density": "1.1",
      "viscosity": "400-600",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "1687",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Nylon-Green Tough",
      "link": "https://amzn.to/4aAzBAf",
      "colors": [
        "#32ac15  |Clear Green"
      ],
      "description": "With an XY planar resolution of 0.047 mm and a layer height of 50 µm (10 sec per layer, 3 sec delay), this resin is perfect for creating prototypes. Cleaning printed models is easy with just an air gun and alcohol spray. Phrozen prioritizes customer service, with a professional engineering team ready to answer questions and help you achieve high-performance prints.",
      "price": "66.19",
      "tensileStrength": "19",
      "flexureStrength": "",
      "elongationAtBreak": "30",
      "impactResistance": "23.79",
      "hardness": "68",
      "uvWavelength": "",
      "density": "",
      "viscosity": "742",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Rock-Black Stiff",
      "link": "https://amzn.to/4bAbTFt",
      "colors": [
        "#000000  |Black"
      ],
      "description": "Features a 0.047 mm XY resolution and a layer height of 50 µm with a 12-second curing time per layer. This resin produces heat-resistant, sturdy, and flexible 3D models, making it ideal for printing industrial parts, gears, and other engineering components. Cleaning is easy with an air gun and alcohol spray.",
      "price": "66.19",
      "tensileStrength": "34",
      "flexureStrength": "",
      "elongationAtBreak": "4",
      "impactResistance": "66.42",
      "hardness": "78",
      "uvWavelength": "",
      "density": "1.14",
      "viscosity": "190",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "1300",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "105",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Protowhite Rigid",
      "link": "https://amzn.to/4bLwZ3k",
      "colors": [
        "#fff     |White"
      ],
      "description": "Enables industrial designers to create rigid, impact-resistant 3D models, enhancing design validation and efficiency. It allows easy visualization of complex prototypes for better communication and quick experimentation with mechanical parts, jigs, fixtures, and more. The resin supports rapid prototyping, helping to gather feedback and identify design improvements before full-scale production. Each 1kg bottle is well-packaged and leak-proof, with professional support provided by Phrozen.",
      "price": "76.69",
      "tensileStrength": "57",
      "flexureStrength": "94",
      "elongationAtBreak": "15",
      "impactResistance": "1.9k",
      "hardness": "77",
      "uvWavelength": "",
      "density": "1.1",
      "viscosity": "220",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1920",
      "youngsModulus": "2300",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "55",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Functional TR300 Ultra High Temp",
      "link": "https://amzn.to/3WUIIZs",
      "colors": [
        "#1d2228  |Dark Grey"
      ],
      "description": "Excellent mechanical properties, including high tensile strength, toughness, and low shrinkage. Ideal for high-temperature applications like dental thermoforming, industrial mock-ups, and jewelry, it features low viscosity for easy printing and cleaning, and low odor to minimize fumes. This ultra-high temp resin can withstand heat up to 156°C.",
      "price": "65.49",
      "tensileStrength": "32",
      "flexureStrength": "",
      "elongationAtBreak": "2",
      "impactResistance": "",
      "hardness": "80",
      "uvWavelength": "",
      "density": "",
      "viscosity": "160",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "1857",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "190",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Phrozen Speed",
      "link": "https://amzn.to/3Kgejxa",
      "colors": [
        "#bbc0cd  |8K Grey"
      ],
      "description": "Prints up to 8 times faster than regular resins, ideal for rapid design iterations and reducing idea-to-product time. It can print large models up to 20cm in under 4 hours, enabling same-day iterations. Perfect for large-size models like cosplay props, masks, shoes, and wargaming terrains, it works with most LCD 3D printers, delivering optimal performance with Phrozen printers and great results with others. Each bottle is well-packaged and leak-proof, with professional support provided by Phrozen.",
      "price": "37.59",
      "tensileStrength": "25",
      "flexureStrength": "",
      "elongationAtBreak": "20",
      "impactResistance": "",
      "hardness": "79",
      "uvWavelength": "",
      "density": "",
      "viscosity": "235",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Ceramic White BASF",
      "link": "https://amzn.to/44XmSGI",
      "colors": [
        "#fff     |White"
      ],
      "description": "With over 50% ceramic content, offers high accuracy, density, and a smooth ceramic-like finish without extra post-thermal treatment. It has an E modulus up to 5800 MPa for high stiffness, wear resistance, and low water absorption. Despite its high ceramic content, it maintains ultra-low viscosity (120 mPas) for fast printing and easy post-processing. Ideal for industrial-grade applications, it produces precise engine prototypes, mock-up parts, and mechanical models, as well as versatile crafts, sculptures, and educational models.",
      "price": "110.19",
      "tensileStrength": "62",
      "flexureStrength": "90",
      "elongationAtBreak": "2",
      "impactResistance": "26",
      "hardness": "",
      "uvWavelength": "",
      "density": "1.45",
      "viscosity": "120",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "5400",
      "youngsModulus": "5800",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "67",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Functional Tough ABS-Like+",
      "link": "https://amzn.to/3UWdwGf",
      "colors": [
        "#bbc0cc  |Grey"
      ],
      "description": "Exceptional versatility for both industrial users and 3D printing enthusiasts, providing remarkable printability and toughness for various applications. It ensures a swift and user-friendly printing experience, combining speed and simplicity. With good tensile strength and impact resistance, it performs reliably across a wide range of needs. High-resolution capabilities and minimal shrinkage guarantee precise, intricate details in every print. This resin sets a new standard with competitive pricing, delivering outstanding quality for industrial prototypes without breaking the bank.",
      "price": "69.29",
      "tensileStrength": "35.8",
      "flexureStrength": "80",
      "elongationAtBreak": "17.7",
      "impactResistance": "66.4",
      "hardness": "75-80",
      "uvWavelength": "",
      "density": "1.11",
      "viscosity": "30-180",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1900",
      "youngsModulus": "2490",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "57",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "phrozen Functional Rigid PC/GF-Like",
      "link": "https://amzn.to/44TaMye",
      "colors": [
        "#000000  |Black"
      ],
      "description": "High precision and resolution, perfect for automotive interiors and prototyping. It provides impressive heat and chemical resistance, making it a great alternative to engineering plastics for industrial applications. Ideal for 3C products, it meets high heat resistance standards and enhances audio quality in devices like headphones and speakers. This resin delivers exceptional strength and durability, ensuring minimal damage to printed objects. Designed for B2B industrial printing, it streamlines development timelines for customized batch testing with precision and reliability.",
      "price": "95.99",
      "tensileStrength": "48.4",
      "flexureStrength": "",
      "elongationAtBreak": "5.5-9.4",
      "impactResistance": "35.5-39.8",
      "hardness": "80",
      "uvWavelength": "",
      "density": "1.12",
      "viscosity": "65-201",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "2567-3330",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "65-95",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Phrozen Aqua Clear Plus",
      "link": "https://phrozen3d.com/products/aqua-resin?variant=44850580652219",
      "colors": [
        "#ffe     |Clear"
      ],
      "description": "Clear with slight yellow tone",
      "price": "38.99",
      "tensileStrength": "23.6",
      "flexureStrength": "",
      "elongationAtBreak": "13",
      "impactResistance": "52.2",
      "hardness": "75-80",
      "uvWavelength": "",
      "density": "1.09",
      "viscosity": "50-150",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "1208.7",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "49.3",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "SUNLU Standard",
      "link": "https://amzn.to/3USAFcM",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#95f5f4  |Clear Blue",
        "#32ac15  |Clear Green",
        "#d94b2d  |Clear Red",
        "#1d2228  |Dark Grey",
        "#40bb7a  |Green",
        "#ece388  |Lemon Yellow",
        "#46cfb1  |Mint Green",
        "#f9925d  |Orange",
        "#f6c7cf  |Sakura Pink",
        "#90daed  |Sky Blue",
        "#cabeee  |Taro Purple",
        "#fff     |White"
      ],
      "description": "SUNLU's standard 3D printer resin cures rapidly, compatible with most 2K/4K/6K/8K resin printers. Designed to reduce volume shrinkage, it ensures high precision and stable performance. Extensively tested for compatibility, it offers a user-friendly experience for both beginners and experts. The resin is easy to clean with isopropyl alcohol or ethanol and has a minimal odor, providing a smooth finish. Available in a wide range of colors, including solid, transparent, and macaron, it allows for creative freedom and vibrant designs.",
      "price": "16.19",
      "tensileStrength": "36",
      "flexureStrength": "40",
      "elongationAtBreak": "10",
      "impactResistance": "30",
      "hardness": "80-85",
      "uvWavelength": "395-405nm",
      "density": "1.16-1.21",
      "viscosity": "100-350",
      "shrinkage": "7-9",
      "printingEnvironmentTemp": "25-30",
      "flexuralModulus": "1430",
      "youngsModulus": "1280",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "55",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "SUNLU ABS -Like",
      "link": "https://amzn.to/3wN5mYS",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#95f5f4  |Clear Blue",
        "#32ac15  |Clear Green",
        "#d94b2d  |Clear Red",
        "#1d2228  |Dark Grey",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Improved toughness and abrasion resistance, making it ideal for printing miniatures and small objects. It features fast curing with low odor, ensuring good stability in humid and corrosive environments. Designed for high precision and low shrinkage, it delivers smooth print results. The resin is widely compatible with 4K and 8K DLP/SLA/LCD 3D printers and comes in various colors to foster creativity. Packaged securely with a leak-proof bottle and tight-fitting airbag, it minimizes the risk of leaks during transport.",
      "price": "39.99",
      "tensileStrength": "34",
      "flexureStrength": "36",
      "elongationAtBreak": "20",
      "impactResistance": "60",
      "hardness": "75-80",
      "uvWavelength": "395-405",
      "density": "1.16-1.22",
      "viscosity": "200-400",
      "shrinkage": "6-8",
      "printingEnvironmentTemp": "25-30",
      "flexuralModulus": "1070",
      "youngsModulus": "1020",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "50",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "SUNLU High Toughness",
      "link": "https://amzn.to/4aAQIBZ",
      "colors": [
        "#000000  |Black",
        "#1d2228  |Dark Grey",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Boasts excellent flexibility and bendability, making printed models durable and unbreakable, ideal for structural and solid parts. Its low viscosity and high flowability ensure better accuracy and printing results, with reduced shrinkage and distortion. Designed to improve printing stability, it minimizes cracking post-curing, enhancing success rates. The resin has a low odor, providing a more comfortable printing environment and is easy to clean with alcohol or ethanol. SUNLU resins are widely compatible with most LCD/DLP/SLA printers, catering to various printing needs.",
      "price": "56.09",
      "tensileStrength": "20",
      "flexureStrength": "20",
      "elongationAtBreak": "50",
      "impactResistance": "120",
      "hardness": "68-72",
      "uvWavelength": "365-405",
      "density": "1.18-1.25",
      "viscosity": "200-350",
      "shrinkage": "6-8",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "829",
      "youngsModulus": "756",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "45",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "SUNLU Water Washable",
      "link": "https://amzn.to/3yx7dSd",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#95f5f4  |Clear Blue",
        "#d94b2d  |Clear Red",
        "#1d2228  |Dark Grey",
        "#40bb7a  |Green",
        "#bbc0cc  |Grey",
        "#f9925d  |Orange",
        "#fff     |White"
      ],
      "description": "Cures quickly and can be cleaned with water, making it convenient and economical. Suitable for 2K/4K/8K resin printers, it offers low shrinkage and high precision, ensuring stability and accuracy. Its high compatibility and easy-to-use nature make it beginner-friendly, while the light odor dissipates quickly after printing. The resin comes in a leak-proof bottle, ensuring safe delivery, and should be stored away from sunlight and sealed to maintain print quality.",
      "price": "24.99",
      "tensileStrength": "30-50",
      "flexureStrength": "35-55",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "80-85",
      "uvWavelength": "395-405",
      "density": "1.06-1.16",
      "viscosity": "150-350",
      "shrinkage": "6-8",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1500-1600",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "SUNLU Plant-Based",
      "link": "https://amzn.to/4bKZVcp",
      "colors": [
        "#000000  |Black",
        "#95f5f4  |Clear Blue",
        "#32ac15  |Clear Green",
        "#d94b2d  |Clear Red",
        "#bbc0cc  |Grey",
        "#f6c7cf  |Sakura Pink",
        "#cabeee  |Taro Purple",
        "#fff     |White"
      ],
      "description": "Offers low shrinkage and high precision due to engineering efforts to minimize volume shrinkage during curing, resulting in accurate and smooth print results. Made primarily from soybean oil, it is BPA-free and environmentally friendly, with printing performance comparable to standard resins. The 405nm plant-based resin cures quickly and provides excellent stability in humid and corrosive environments. Optimized for wide compatibility, it works with various DLP/SLA/LCD resin 3D printers and comes in multiple colors to enhance user creativity.",
      "price": "40.59",
      "tensileStrength": "20-35",
      "flexureStrength": "20-40",
      "elongationAtBreak": "5-12",
      "impactResistance": "",
      "hardness": "80-85",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "7-9",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "600-800",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "SUNLU Nylon-Like",
      "link": "https://amzn.to/4bPWUHf",
      "colors": [
        "#000000  |Black",
        "#bbc0cc  |Grey",
        "#f0c2ac  |Light Beige",
        "#fff     |White"
      ],
      "description": "Stronger and tougher than ABS-like or standard resins, making it ideal for printing high-precision 3D models with excellent toughness and durability. It has low shrinkage and high precision, ensuring fast curing and good stability. The resin is rigorously tested for aging resistance, remaining intact even after three months at 55°C. The leak-proof bottle design ensures safe delivery and reduces the risk of damage during transport.",
      "price": "49.59",
      "tensileStrength": "20-45",
      "flexureStrength": "25-50",
      "elongationAtBreak": "20-50",
      "impactResistance": "",
      "hardness": "75-80",
      "uvWavelength": "395-405",
      "density": "1.06-1.16",
      "viscosity": "100-300",
      "shrinkage": "6-8",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "650-900",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "SUNLU Water-Wash ABS",
      "link": "https://amzn.to/3UT9UVM",
      "colors": [
        "#000000  |Black",
        "#1d2228  |Dark Grey",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Combines the toughness of ABS-like resin with the convenience of water-washable resin, offering better cleaning and clearer details. It features fast curing and low odor, with good stability in humid and corrosive environments. Engineers optimized it for low shrinkage and high precision, ensuring smooth print results.",
      "price": "26.34",
      "tensileStrength": "",
      "flexureStrength": "",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "365-405",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "SUNLU High-Temperature",
      "link": "https://amzn.to/4atAZEN",
      "colors": [
        "#000000  |Black",
        "#1d2228  |Dark Grey",
        "#fff     |White"
      ],
      "description": "Resists up to 180°C for 15 minutes, 150°C for 1 hour, and 80°C for 7 days, ensuring high thermal stability and preventing cracking and warping. It is ideal for printing small injection molds, such as candlesticks, due to its high hardness of 88D, providing impact resistance and preventing deformation. The resin's fast curing speed improves printing efficiency and reduces curing time while maintaining high strength and low shrinkage.",
      "price": "44.19",
      "tensileStrength": "43",
      "flexureStrength": "54",
      "elongationAtBreak": "8",
      "impactResistance": "48",
      "hardness": "88",
      "uvWavelength": "395-405",
      "density": "1.24-1.30",
      "viscosity": "250-550",
      "shrinkage": "7-9",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "2057",
      "youngsModulus": "2070",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "130",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "SUNLU Standard Plus",
      "link": "https://amzn.to/3yz8gRH",
      "colors": [
        "#789299  |Blue Grey",
        "#1d2228  |Dark Grey",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "An enhanced version of standard resin, offering higher printing accuracy, lower volume shrinkage, and greater toughness for improved performance. Its low-shrinkage formula ensures exceptional precision and stability. Extensively tested for compatibility with various printers, it provides a user-friendly experience for both beginners and experts. The resin cleans easily with isopropyl alcohol or ethanol and emits minimal odor.",
      "price": "20.59",
      "tensileStrength": "",
      "flexureStrength": "",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "SUNLU 10K Red Wax",
      "link": "https://amzn.to/3WRM7YM",
      "colors": [
        "#c7734a  |Red Wax"
      ],
      "description": "The SUNLU 10K Red Wax 3D Printer Resin is designed for ultra-detail 3D printing, offering high precision, better liquidity, and toughness. It features fast curing, ensuring excellent print quality and fine details. The resin's low shrinkage during curing provides stability and prevents deformation or cracking. It has a low odor, making it more comfortable to use, and is easy to clean with alcohol or ethanol. This resin is widely compatible with most LCD printers and is ideal for applications requiring high-detail prints​",
      "price": "35.59",
      "tensileStrength": "",
      "flexureStrength": "",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "405",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "SUNLU 14K High Precision",
      "link": "https://amzn.to/3UUMD5R",
      "colors": [
        "#000000  |Black",
        "#1d2228  |Dark Grey",
        "#bbc0cc  |Grey",
        "#72362a  |Mahogany",
        "#8c6745  |Maple",
        "#c7734a  |Red Wax",
        "#503a35  |Walnut",
        "#fff     |White"
      ],
      "description": "Exceptional detail and a matte texture, making 3D printed models more expressive and vivid, ideal for detailed figures. Enhances light resistance, accurately displaying model details and maintaining original color and effect after rapid curing. It features low shrinkage, ensuring stability and preventing deformation or cracking. The resin emits a low odor, creating a more comfortable printing environment and is easy to clean with alcohol or ethanol.",
      "price": "37.79",
      "tensileStrength": "",
      "flexureStrength": "",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Creality 8K Resin",
      "link": "https://amzn.to/4bQW9O5",
      "colors": [
        "#67c4de  |Blue",
        "#ffe     |Clear",
        "#1d2228  |Dark Grey",
        "#bbc0cc  |Grey",
        "#f9925d  |Orange",
        "#f8e3c2  |Skin"
      ],
      "description": "Offers fast curing and strong stability, reducing forming time and ensuring successful printing with its fluidity and proper hardness. It features high precision and low shrinkage, producing smooth, artwork-like models. The resin is easy to clean with isopropyl alcohol or ethanol and has a light odor that dissipates quickly. The leak-proof bottle design, packed securely, ensures safe delivery. It is widely compatible with most 8K resin 3D printers, including Creality, ELEGOO, Anycubic, Phrozen, and UniFormation models.",
      "price": "22.78",
      "tensileStrength": "",
      "flexureStrength": "",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Creality Water Washable",
      "link": "https://amzn.to/3X121zY",
      "colors": [
        "#bbc0cc  |Grey",
        "#f8e3c2  |Skin",
        "#fff     |White"
      ],
      "description": "Easy to clean with water or a Creality Wash and Cure Machine due to its high water solubility. Offers fast curing, excellent fluidity, and stability, reducing printing time and preventing deformation. The resin ensures low shrinkage and high precision, producing smooth, detailed models. It is ideal for DLP/LCD 3D printers.",
      "price": "15.98",
      "tensileStrength": "30-46",
      "flexureStrength": "45-75",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "78-79",
      "uvWavelength": "405",
      "density": "1.05-1.15",
      "viscosity": "150-250",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Creality Standard Rigid",
      "link": "https://store.creality.com/collections/materials/products/standard-rigid-lcd-uv-resin-1kg",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#95f5f4  |Clear Blue",
        "#32ac15  |Clear Green",
        "#d94b2d  |Clear Red",
        "#bbc0cc  |Grey",
        "#f8e3c2  |Skin",
        "#fff     |White"
      ],
      "description": "This budget-friendly resin is cost-effective for beginners and compatible with 90% of LCD resin printers, especially Creality models. It offers high precision, strength, and durability, made from carefully selected materials with a low odor.",
      "price": "25",
      "tensileStrength": "68",
      "flexureStrength": "",
      "elongationAtBreak": "",
      "impactResistance": "7.5K",
      "hardness": "85-90",
      "uvWavelength": "405",
      "density": "1.14",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Loctite IND405 Tough",
      "link": "https://www.imakr.com/loctite-resins/4429-5702-loctite-3d-ind405-hdt50-high-elongation#/33-colors-black",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear"
      ],
      "description": "A robust resin with exceptional impact resistance and an excellent surface finish. This highly durable material is ideal for applications such as tool production, manufacturing aids, and final parts. https://dm.henkel-dam.com/is/content/henkel/Loctite-3D-IND405-HDT50-High-Elongation",
      "price": "180",
      "tensileStrength": "45",
      "flexureStrength": "",
      "elongationAtBreak": "101",
      "impactResistance": "51",
      "hardness": "76",
      "uvWavelength": "",
      "density": "1.21",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1320-1446",
      "youngsModulus": "1400",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "53",
      "heatCapacity": "0.63-0.77",
      "curingTemp": ""
    },
    {
      "name": "Loctite 3D IND249",
      "link": "https://www.imakr.com/loctite-resins/4832-loctite-3d-ind249-bk-high-strength-resin",
      "colors": [
        "#000000  |Black"
      ],
      "description": "a low viscosity industrial resin known for its exceptional strength, stiffness, and thermal durability, making it perfect for printing intricate geometries with fine feature resolution. Loctite 3D resins are compatible with various DLP 3D printers. https://dm.henkel-dam.com/is/content/henkel/Loctite-3D-IND249-BK",
      "price": "260.00",
      "tensileStrength": "83-98",
      "flexureStrength": "127-153",
      "elongationAtBreak": "4-7",
      "impactResistance": "13-24",
      "hardness": "81-88",
      "uvWavelength": "",
      "density": "1.17-1.2",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "3170-3600",
      "youngsModulus": "2980-3350",
      "flexuralStrainAtBreak": "4-5",
      "flexuralStressAtMax": "",
      "hdt": "113-117",
      "heatCapacity": "1.4-1.5",
      "curingTemp": ""
    },
    {
      "name": "LOCTITE 3D IND402",
      "link": "https://www.imakr.com/loctite-resins/3572-4489-loctite-3d-ind402-a70-high-rebound#/33-colors-black/610-size-1_litre",
      "colors": [
        "#000000  |Black",
        "#bbc0cc  |Grey"
      ],
      "description": "Strong compression resilience, maintaining tensile strength and interlayer adhesion, making it ideal for consumer and industrial elastomeric applications, such as midsoles and soft inserts. It prints well on DLP and SLA printers without requiring thermal post-processing, though a post-processing routine is recommended for optimal properties.\n\nCleaning: IPA 2 min 2 intervals dry inbetween intervals. Dry with 30 psi compressed air 30 s. Post cure after 60 min. Post cure: 30 mW/cm² at 365 nm 5 min, or 148 mW/cm² at 380 nm 2 min. https://dm.henkel-dam.com/is/content/henkel/Loctite-3D-IND402-A70-High-Rebound",
      "price": "250",
      "tensileStrength": "5.3-5.7",
      "flexureStrength": "",
      "elongationAtBreak": "220-240",
      "impactResistance": "",
      "hardness": "82",
      "uvWavelength": "",
      "density": "1.1",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "37-47",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "1.8-2.2",
      "curingTemp": ""
    },
    {
      "name": "AmeraLabs TGM-7",
      "link": "https://amzn.to/4dRqsG9",
      "colors": [
        "#ffe     |Clear",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Favored by miniature 3D printing businesses and hobbyists, is known for its durability and slight flexibility, preventing breakage during shipping, painting, and gaming. It captures high details, impressing customers with intricate expressions. After a brief post-curing, the miniatures have a hard, non-sticky surface that is pleasant to touch and easy to paint.",
      "price": "89",
      "tensileStrength": "38.4",
      "flexureStrength": "",
      "elongationAtBreak": "61.6",
      "impactResistance": "",
      "hardness": "78",
      "uvWavelength": "365-420",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "LOCTITE 3D PRO9274",
      "link": "https://www.matterhackers.com/store/l/loctite-3d-pro9274-resin/sk/MJAMKPGA",
      "colors": [
        "#bbc0cc  |Grey"
      ],
      "description": "A versatile, dark gray resin ideal for precise DLP/LCD prototyping. It features easy printing, high detail, durability, and cost-effectiveness, making it suitable for various applications like prototypes, jigs, and fixtures in the automotive and consumer goods sectors. https://dm.henkel-dam.com/is/content/henkel/Loctite-3D-PRO9274",
      "price": "80",
      "tensileStrength": "31 – 36",
      "flexureStrength": "78 – 83",
      "elongationAtBreak": "7 – 11",
      "impactResistance": "25 – 28",
      "hardness": "79 – 82",
      "uvWavelength": "",
      "density": "1.16",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "2100 – 2300",
      "youngsModulus": "1400-1700",
      "flexuralStrainAtBreak": "4.5 – 5",
      "flexuralStressAtMax": "",
      "hdt": "52",
      "heatCapacity": "",
      "curingTemp": "20-35"
    },
    {
      "name": "LOCTITE 3D MED414",
      "link": "https://www.matterhackers.com/store/l/loctite-3d-med414-resin/sk/MU8LU2A6",
      "colors": [
        "#95f5f4  |Clear Blue"
      ],
      "description": "A medical-grade, TPO-free photopolymer designed for elastomeric medical devices and skin contact applications. It offers true elastomeric behavior, exceptional tear strength, torsional flexibility, and meets ISO 10993-5 & -10 biocompatibility standards. With a vibrant blue color option and high print resolution, it is ideal for durable, flexible healthcare applications. https://dm.henkel-dam.com/is/content/henkel/Loctite-3D-MED414-A50-Blue",
      "price": "450",
      "tensileStrength": "2.5-2.8",
      "flexureStrength": "",
      "elongationAtBreak": "220-240",
      "impactResistance": "",
      "hardness": "51",
      "uvWavelength": "",
      "density": "1.02",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "9-15",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": "20-35"
    },
    {
      "name": "LOCTITE 3D MED412",
      "link": "https://www.matterhackers.com/store/l/loctite-3d-med412-resin/sk/MQURXG7F",
      "colors": [
        "#ffe     |Clear",
        "#fff     |White"
      ],
      "description": "A medical-grade photopolymer resin that combines high strength, durability, and flexibility similar to polypropylene. Available in clear and white, it provides excellent elongation, and wear resistance, and is sterilizable. It meets ISO 10993-5, -10, and -23 biocompatibility standards and is compatible with various DLP machines, making it ideal for safe and versatile medical manufacturing. https://dm.henkel-dam.com/is/content/henkel/Loctite-3D-MED412-HDT40-High-Impact",
      "price": "430",
      "tensileStrength": "35 - 40",
      "flexureStrength": "",
      "elongationAtBreak": "105 - 115",
      "impactResistance": "47 - 52",
      "hardness": "70",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "1250 - 1400",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "38 - 40",
      "heatCapacity": "",
      "curingTemp": "20-25"
    },
    {
      "name": "LOCTITE 3D PRO410",
      "link": "https://www.matterhackers.com/store/l/loctite-3d-pro410-hdt70-high-accuracy-black-resin-1kg/sk/MV8JCDPR",
      "colors": [
        "#ffe     |Clear"
      ],
      "description": "A high-accuracy rigid resin for fast, precise 3D printing, ideal for printer calibration. It prints three times faster than traditional resins and provides a professional surface finish, suitable for industrial, automotive, and consumer goods applications. Designed for open-source SLA and DLP 3D printers (385-420nm). https://dm.henkel-dam.com/is/content/henkel/Loctite-3D-PRO410-High-Accuracy",
      "price": "80",
      "tensileStrength": "38-49",
      "flexureStrength": "82-86",
      "elongationAtBreak": "4-7",
      "impactResistance": "20-28",
      "hardness": "83-85",
      "uvWavelength": "",
      "density": "1.354",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "2480-2520",
      "youngsModulus": "1630-1990",
      "flexuralStrainAtBreak": "5",
      "flexuralStressAtMax": "",
      "hdt": "66-76",
      "heatCapacity": "1.21-1.23",
      "curingTemp": ""
    },
    {
      "name": "LOCTITE 3D MED413",
      "link": "https://www.matterhackers.com/store/l/loctite-3d-med413-resin/sk/M5DDAKZS",
      "colors": [
        "#ffe     |Clear",
        "#fff     |White"
      ],
      "description": "a medical-grade photopolymer resin ideal for creating durable, impact-resistant medical devices like hearing aids. It offers a combination of stiffness and toughness, performing well at body temperature with excellent surface finish and machinability. Available in clear and white, it meets ISO 10993-5 & -10 biocompatibility standards. Key properties include 50% elongation at break, 1600 MPa tensile modulus, 40 MPa ultimate tensile strength, and a 70°C heat deflection temperature. Compatible with various DLP machines, its performance is validated with specific Henkel workflows. https://dm.henkel-dam.com/is/content/henkel/Loctite-3D-MED413-HDT60-High-Tough",
      "price": "430",
      "tensileStrength": "40-48",
      "flexureStrength": "",
      "elongationAtBreak": "40-55",
      "impactResistance": "50-65",
      "hardness": "76",
      "uvWavelength": "",
      "density": "1.2",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1500-1600",
      "youngsModulus": "1600-1750",
      "flexuralStrainAtBreak": "5",
      "flexuralStressAtMax": "",
      "hdt": "66-70",
      "heatCapacity": "",
      "curingTemp": "20-25"
    },
    {
      "name": "LOCTITE 3D MED9851",
      "link": "https://www.matterhackers.com/store/l/loctite-3d-med9851-resin/sk/MG4J0PR4",
      "colors": [
        "#ffe     |Clear"
      ],
      "description": "A clear, high-performance resin for durable medical devices, offering excellent tensile, flexural properties, and high impact strength. It meets ISO 10993 biocompatibility standards, functions at body temperature or higher, and has a good surface finish. Key specs include 40% elongation at break, 2,300 MPa Young’s Modulus, and 68°C heat deflection temperature. https://dm.henkel-dam.com/is/content/henkel/Loctite-3D-MED9851-Clear",
      "price": "430",
      "tensileStrength": "40-45",
      "flexureStrength": "",
      "elongationAtBreak": "35-40",
      "impactResistance": "40-50",
      "hardness": "80-81",
      "uvWavelength": "",
      "density": "1.18",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "2100-2300",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "65-68",
      "heatCapacity": "",
      "curingTemp": "20-35"
    },
    {
      "name": "LOCTITE 3D IND147",
      "link": "https://www.matterhackers.com/store/l/loctite-3d-ind147-carbon-m-series-certified-resin-1kg/sk/M3E71VZN",
      "colors": [
        "#000000  |Black"
      ],
      "description": "a high-stiffness, high-temperature photopolymer resin. This easy-to-use, one-part resin simplifies processing, saving time and labor. It is ideal for printing molds, fixtures, and manufacturing tools with smooth surfaces and accurate dimensions for high-heat applications in industry, consumer, and automotive markets. Certified for Carbon® printers. https://dm.henkel-dam.com/is/content/henkel/Loctite-3D-IND147",
      "price": "260",
      "tensileStrength": "67",
      "flexureStrength": "120",
      "elongationAtBreak": "2",
      "impactResistance": "14.6",
      "hardness": "94",
      "uvWavelength": "",
      "density": "1.26",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "3690",
      "youngsModulus": "3190",
      "flexuralStrainAtBreak": "3.5",
      "flexuralStressAtMax": "",
      "hdt": "235-291",
      "heatCapacity": "1.3",
      "curingTemp": "20-35"
    },
    {
      "name": "LOCTITE 3D PRO417",
      "link": "https://www.matterhackers.com/store/l/loctite-3d-pro417-resin-1kg/sk/MU6MR5RX",
      "colors": [
        "#000000  |Black"
      ],
      "description": "a high-strength, impact-resistant photoplastic with moderate heat resistance (HDT of 49°C) and an excellent surface finish. It offers high green strength for accurate room-temperature printing and is compatible with various DLP and LCD machines. Suitable for industrial, automotive, and consumer goods, it is ideal for manufacturing aids, jigs, fixtures, housings, covers, and insoles. Designed for open-source SLA and DLP 3D printers (385-420nm). https://dm.henkel-dam.com/is/content/henkel/Loctite-3D-PRO417-BK",
      "price": "120",
      "tensileStrength": "38-40",
      "flexureStrength": "",
      "elongationAtBreak": "94-105",
      "impactResistance": "52-54",
      "hardness": "63-64",
      "uvWavelength": "",
      "density": "1.12",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "844-952",
      "youngsModulus": "1212-1384",
      "flexuralStrainAtBreak": "5",
      "flexuralStressAtMax": "",
      "hdt": "48-49",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "XIAOJIN EZprint 8K",
      "link": "https://amzn.to/4aUKbSU",
      "colors": [
        "#bbc0cc  |Grey",
        "#f0c2ac  |Light Beige",
        "#fff     |White"
      ],
      "description": "Accurately reproduces fine 3D details such as grooves, textures, hairs, holes, and protrusions, maintaining sharpness even after painting or molding. It is user-friendly and tolerant to changes in supports, print settings, temperature, and humidity, compatible with most LCD/MSLA/DLP 3D printers. Resin residue cleans easily with alcohol or IPA without needing post-curing, ensuring non-sticky, crack-free surfaces. Made from high-purity materials, it emits low odor, making it suitable for office or home use. Tested outdoors for three months, the prints remained stable and moisture-resistant.",
      "price": "29.99",
      "tensileStrength": "60",
      "flexureStrength": "99",
      "elongationAtBreak": "8.6",
      "impactResistance": "18.5",
      "hardness": "90",
      "uvWavelength": "385-405",
      "density": "",
      "viscosity": "310",
      "shrinkage": "",
      "printingEnvironmentTemp": "20-35",
      "flexuralModulus": "2400",
      "youngsModulus": "1500",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "72",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "AmeraLabs XVN-50",
      "link": "https://amzn.to/45aCjep",
      "colors": [
        "#000000  |Black"
      ],
      "description": "Offers a blend of flexibility and rigidity, ensuring strength and impact resistance for durable 3D prints. The 12K resin guarantees precise, dimensionally accurate prints with minimal shrinkage and stable pigments. XVN-50 resin is ideal for high-resolution prototyping and industrial design, producing detailed prints. The versatile black liquid resin provides a solid, smooth surface for various applications, from prototypes to end-use parts. Non-brittle prints allow easy post-processing, making drilling, cutting, machining, or tapping simple. https://cdn.ameralabs.com/wp-content/uploads/2023/09/XVN-50-Technical-datasheet.pdf",
      "price": "89.99",
      "tensileStrength": "43.4",
      "flexureStrength": "62.3",
      "elongationAtBreak": "51.2",
      "impactResistance": "5.9",
      "hardness": "82",
      "uvWavelength": "365-420",
      "density": "1.213",
      "viscosity": "560",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1820",
      "youngsModulus": "2030",
      "flexuralStrainAtBreak": "6.7",
      "flexuralStressAtMax": "",
      "hdt": "62.8",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "AmeraLabs SiOmaster",
      "link": "https://amzn.to/3X32KAU",
      "colors": [
        "#bbc0cc  |Grey"
      ],
      "description": "Withstands high-temperature silicone vulcanizations up to 180°C without breaking. It produces hard, detailed models that resist bending under pressure during vulcanization. The resin replicates digital designs with exceptional precision, capturing every detail. Supports are easily removed, leaving minimal marks. Low shrinkage ensures model accuracy, reducing the need for adjustments and ensuring precise production.",
      "price": "92.00",
      "tensileStrength": "",
      "flexureStrength": "",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "AmeraLabs DMD-31",
      "link": "https://amzn.to/3X6UP5s",
      "colors": [
        "#f0c2ab  |Beige"
      ],
      "description": "Produces highly accurate and stable prints with straight edges and fine details due to its stiffness and hardness. Supports remain firm during printing, ensuring successful complex prints. The material offers excellent dimensional stability and low flexibility, producing precise models with minimal shrinkage, maintaining the original features. Pigment dispersion is stabilized, preventing settling during long vertical printing sessions. It is compatible with most LCD/MSLA/DLP 4K/8K/12K 3D printers.",
      "price": "107",
      "tensileStrength": "",
      "flexureStrength": "",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "RESIONE Tough",
      "link": "https://amzn.to/4aJOD6F",
      "colors": [
        "#000000  |Black",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Offers mechanical properties similar to tough thermoplastics, with high tensile and impact strength, allowing for drilling and nailing in fragile areas. The resin's hard surface is wear-resistant and scratch-resistant, ideal for movable joints, gears, and bearing parts. It provides clear, sharp details with high molding accuracy and minimal overexposure. M58 can be mixed with F69/F39/F39T resins to enhance toughness and durability. Compatible with 385~405nm UV LED light sources, it suits most LCD/MSLA/DLP resin 3D printers.",
      "price": "24.24",
      "tensileStrength": "2.3",
      "flexureStrength": "68.2",
      "elongationAtBreak": "12.3",
      "impactResistance": "51.4",
      "hardness": "87",
      "uvWavelength": "",
      "density": "",
      "viscosity": "307",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "65",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "AmeraLabs DMD-21",
      "link": "https://amzn.to/4594v1k",
      "colors": [
        "#f0c2ab  |Beige"
      ],
      "description": "Fast curing resin speeds up 3D printing. Dental resin with low shrinkage (less than 0.9%) ensures dimensionally accurate and stable models. Available in an attractive sand color.",
      "price": "107",
      "tensileStrength": "55",
      "flexureStrength": "",
      "elongationAtBreak": "6",
      "impactResistance": "",
      "hardness": "80-90",
      "uvWavelength": "365-420",
      "density": "",
      "viscosity": "180-200",
      "shrinkage": "1",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "RESIONE TH72",
      "link": "https://amzn.to/3KqFBAX",
      "colors": [
        "#bbc0cc  |Grey"
      ],
      "description": "Extremely durable, resisting damage from drops and transportation, even when bent or folded with wall thicknesses under 3mm, making them ideal for resilient figures. They maintain long-lasting toughness, remaining non-brittle despite exposure to subtropical summers, sunshine, rain, and high-temperature drying. Engineered to resist cracking in hollow designs, TH72 prints save material and ensure longevity. With a water absorption rate of only 0.6% in 48 hours, they resist softening and cracking in humid conditions. As a toughening agent, TH72 enhances the durability of rigid/standard resins when mixed at 40%. Support no less than 1.2mm in diameter.",
      "price": "35.99",
      "tensileStrength": "23",
      "flexureStrength": "",
      "elongationAtBreak": "25.4",
      "impactResistance": "18",
      "hardness": "74-78",
      "uvWavelength": "385-405",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "FLASHFORGE ",
      "link": "https://amzn.to/3Kp64yO",
      "colors": [
        "#fff     |White"
      ],
      "description": "Delivering exceptional quality and achieving an unparalleled level of precision, our resins ensure your prints capture every intricate detail with astonishing clarity. With fast curing properties, they significantly reduce printing time, eliminating long waiting periods. By minimizing volume shrinkage during the photocuring process, our resins maintain the integrity of your designs, ensuring accurate and dimensionally stable prints.",
      "price": "16.69",
      "tensileStrength": "",
      "flexureStrength": "",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "RESIONE Water Fairy",
      "link": "https://amzn.to/4bJEBnu",
      "colors": [
        "#ffe     |Clear",
        "#32ac15  |Clear Green",
        "#fc9565  |Clear Orange",
        "#c4bdf7  |Clear Purple",
        "#bbc0cc  |Grey"
      ],
      "description": "A true water washable resin, allowing residual resin on printed parts to be easily washed away with water, leaving no oily residue or whiteness. With a viscosity of 15mpa.s (25°C), nearly equivalent to water, it supports high-speed printing and adapts to larger sizes, using standard printer resin parameters without extensive testing, ideal for beginners. It is almost odorless and safe, containing high-purity materials without emitting harmful substances, as confirmed by third-party reports complying with the EU RoHS 2.0 directive. The resin delivers high precision and sharp details, accurately presenting fine 3D data such as grooves, textures, and holes, maintaining sharpness even after post-processing. Post-cured parts resist cracking and moisture, although they should not be exposed to water for extended periods.",
      "price": "37.99",
      "tensileStrength": "30",
      "flexureStrength": "47",
      "elongationAtBreak": "7.9",
      "impactResistance": "17.4",
      "hardness": "80",
      "uvWavelength": "385-405",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1480",
      "youngsModulus": "585",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "3DMaterials SuperFlex",
      "link": "https://amzn.to/3RaOjqw",
      "colors": [
        "#ffe     |Clear"
      ],
      "description": "A resin for monochrome LCD 3D printers, offers fast printing at 50um layers in 1.7 seconds, enhancing productivity by 40% or more, while providing balanced softness and strength (80A Shore hardness, 150% elongation at break) suitable for hard flexible prototypes, cushioning, damping, and shock absorption, and properly post-cured prints pass ISO 10993-5 testing.",
      "price": "29.80",
      "tensileStrength": "5.5",
      "flexureStrength": "",
      "elongationAtBreak": "80",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "32",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "3DMaterials SuperElastic",
      "link": "https://amzn.to/4aMJkU6",
      "colors": [
        "#ffe     |Clear"
      ],
      "description": "A resin for monochrome LCD 3D printers, enables fast printing at 50um layers in 1.3 seconds, boosting productivity by 40%+ while offering balanced softness and resilience (60A Shore hardness, 150% elongation at break), making it ideal for printing human skins, faces, buttons, and hair, simulating two-component silicone prototypes, and properly post-cured prints pass ISO 10993-5 testing.",
      "price": "37.90",
      "tensileStrength": "1.3",
      "flexureStrength": "",
      "elongationAtBreak": "46",
      "impactResistance": "",
      "hardness": "60",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "4.6",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "3DMaterials SuperPCS",
      "link": "https://amzn.to/3RhF0oT",
      "colors": [
        "#000000  |Black"
      ],
      "description": "Tough and durable resin compatible with all LCD 3D printers, offers fast printing at 50um layers in 1.5 seconds, enhancing productivity by 40%+, with high precision and extremely low viscosity for 8K resolution at 22um, making it ideal for high-speed, high-resolution 3D printing.",
      "price": "39.80",
      "tensileStrength": "48",
      "flexureStrength": "",
      "elongationAtBreak": "15",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "2800",
      "youngsModulus": "1700",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "3DMaterials SuperPP",
      "link": "https://amzn.to/4c2HBLq",
      "colors": [
        "#ffe     |Clear"
      ],
      "description": "Tough and durable resin compatible with all LCD 3D printers, enables fast printing at 50um layers in 1.3 seconds, boosting productivity by 40%+, with high strength, and properly post-cured prints pass ISO 10993-5 testing, making it suitable for a wide range of applications.",
      "price": "39.80",
      "tensileStrength": "42",
      "flexureStrength": "",
      "elongationAtBreak": "25",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "2400",
      "youngsModulus": "1400",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "3DMaterials SuperHDT",
      "link": "https://amzn.to/4c3iwQl",
      "colors": [
        "#fc9565  |Clear Orange"
      ],
      "description": "Heat-resistant additive for standard resins, offers the highest heat deflection temperature of 464°F in the world. When added to standard resins, it substantially increases the HDT of the print. Before use, warm the bottle at 140°F for an hour or 120°F for a few hours to remelt the resin. Post-cure prints with 20mW/cm2 395-405nm LED light for 10 minutes, then heat in a 176°F oven for one hour. Properly post-cured prints pass ISO 10993-5 testing.",
      "price": "34.80",
      "tensileStrength": "39.5",
      "flexureStrength": "",
      "elongationAtBreak": "2",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "3011",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "240",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "3DMaterials SuperRigid",
      "link": "https://amzn.to/4c6ATEg",
      "colors": [
        "#fff     |White"
      ],
      "description": "Ceramic-like resin compatible with all LCD 3D printers, contains 40% nano-micron ceramic powder for strong, industrial-grade prototypes. With high modulus (6.0GPa tensile and 8.0GPa flexural) and density, it simulates the stiffness and surface texture of ceramics, stone, and cement. Properly post-cured prints pass ISO 10993-5 testing, making it suitable for a wide range of applications.",
      "price": "48.90",
      "tensileStrength": "59",
      "flexureStrength": "",
      "elongationAtBreak": "1.3",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "1",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "5547",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "3DMaterials SuperCast",
      "link": "https://amzn.to/3KtOvNZ",
      "colors": [
        "#c4bdf7  |Clear Purple"
      ],
      "description": "Wax-filled resin compatible with all LCD 3D printers, offers strength and stiffness for printing ultrafine filigree designs. With extremely low viscosity, it allows for high-speed, high-resolution 8K printing at 22um. Burns out completely at lower temperatures without leaving any ash, making it ideal for casting applications. Importantly, post-curing is not required and will result in incomplete burning.",
      "price": "39.80",
      "tensileStrength": "",
      "flexureStrength": "",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "eSUN ABS-Like",
      "link": "https://amzn.to/45cqep5",
      "colors": [
        "#000000  |Black",
        "#67c4de  |Blue",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "offers high toughness, rigidity, impact strength, wear resistance, and mechanical properties, making it suitable for parts requiring both rigidity and toughness. The resin contains polyurethane acrylate monomers to reduce volume shrinkage during photocuring, ensuring high precision and smooth finishes. With excellent fluidity and stability, it quickly infiltrates models, improves print speed, shortens curing time, and provides good adhesion and easy detachment. Specially designed for LED light sources and featuring high-quality pigments and photo-initiators, the resin produces pure, stunning colors. ",
      "price": "36.99",
      "tensileStrength": "30-60",
      "flexureStrength": "30-75",
      "elongationAtBreak": "35-52",
      "impactResistance": "40-110",
      "hardness": "75-81",
      "uvWavelength": "395-405",
      "density": "1.08-1.12",
      "viscosity": "200-300",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Chitu Systems Conjure Rigid",
      "link": "https://amzn.to/4aSjLRs",
      "colors": [
        "#000000  |Black",
        "#ffe     |Clear",
        "#95f5f4  |Clear Blue",
        "#bbc0cc  |Grey"
      ],
      "description": "ultra-low shrinkage (0.2%~0.7%), ideal for articulated figures and mechanical parts. With good machinability, it can be turned, milled, and tapped directly after post-curing. The resin offers high toughness and rigidity (85-90D hardness, 37% elongation at break), making prints non-brittle and durable. It's a great choice for functional gadgets and FDM printing with PLA-ABS. Compatible with 385-405nm UV light, the higher viscosity resin provides better mechanical quality.",
      "price": "34.99",
      "tensileStrength": "39.13",
      "flexureStrength": "46.6",
      "elongationAtBreak": "35.66",
      "impactResistance": "",
      "hardness": "80-85",
      "uvWavelength": "",
      "density": "1.05-1.13",
      "viscosity": "250",
      "shrinkage": "0.2-0.7",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "497",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "80",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Chitu Systems Conjure Sculpt",
      "link": "https://amzn.to/3X8q0O3",
      "colors": [
        "#f0c2ab  |Beige",
        "#bbc0cc  |Grey"
      ],
      "description": "Extremely smooth surface, making it the best choice for highly detailed miniatures and display pieces. More durable than standard resin, prints are unbreakable when dropped from a desk. Despite its higher viscosity and increased difficulty in printing, the resin provides better machinability and is worth trying for those seeking the best surface quality.",
      "price": "34.99",
      "tensileStrength": "24.6",
      "flexureStrength": "23.5",
      "elongationAtBreak": "32.5",
      "impactResistance": "",
      "hardness": "80",
      "uvWavelength": "",
      "density": "1.05-1.13",
      "viscosity": "450",
      "shrinkage": "0.2",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "289",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "80",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Chitu Systems Conjure Standard 8K",
      "link": "https://amzn.to/4577cR7",
      "colors": [
        "#000000  |Black",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "While more brittle than functional resins, it provides upgraded strength and durability compared to first-generation standard resins, making it suitable for functional prototypes and mechanical assemblies. Users can expect exceptional performance with enhanced printing precision, remarkable details, consistent curing without discoloration, and a smooth surface finish.",
      "price": "23.99",
      "tensileStrength": "",
      "flexureStrength": "47.8",
      "elongationAtBreak": "15",
      "impactResistance": "",
      "hardness": "80-86",
      "uvWavelength": "385-410",
      "density": "1.05-1.25",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "518",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "66",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Chitu Systems Conjure Tough",
      "link": "https://amzn.to/4ebJ4kz",
      "colors": [
        "#000000  |Black",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Non-brittle and durable prints with ultra-low shrinkage. The resin can be mixed with standard resin to reduce brittleness, and its high toughness provides good flexibility and protection against drops.",
      "price": "34.99",
      "tensileStrength": "26",
      "flexureStrength": "15",
      "elongationAtBreak": "50.29",
      "impactResistance": "",
      "hardness": "80",
      "uvWavelength": "",
      "density": "1.05-1.13",
      "viscosity": "300",
      "shrinkage": "0.2-0.7",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "310",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "80",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Chitu Systems Water Washable",
      "link": "https://amzn.to/4c9FXI5",
      "colors": [
        "#000000  |Black",
        "#1d2228  |Dark Grey",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Designed for faster post-processing, easier support removal, and a more eco-friendly printing experience. It's less smelly than traditional resins and works with a wide range of DLP/LCD 3D printers.",
      "price": "25.99",
      "tensileStrength": "",
      "flexureStrength": "",
      "elongationAtBreak": "15.66",
      "impactResistance": "",
      "hardness": "84",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "0.7",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "YOUSU 3D Printer Metallic",
      "link": "https://amzn.to/4c6qsk8",
      "colors": [
        "#f0c2ab  |Beige",
        "#789299  |Blue Grey",
        "#ffbbcd  |Dual Color Orange Pink",
        "#d261a9  |dual Color orange Purple",
        "#b0adda  |Dual Color Purple Blue",
        "#bbc0cc  |Grey",
        "#d9cb79  |Metalic Gold",
        "#4597bc  |Metallic Bluezinc",
        "#95483d  |Metallic Copper",
        "#ea7689  |Metallic Rose Red",
        "#d3d3d3  |Metallic Silver",
        "#fff     |White"
      ],
      "description": "Eye-catching metallic effects and high precision with low shrinkage.",
      "price": "39.99",
      "tensileStrength": "30-45",
      "flexureStrength": "50-60",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "80",
      "uvWavelength": "365-405",
      "density": "1.15-1.2",
      "viscosity": "150-250",
      "shrinkage": "3.72-4.24",
      "printingEnvironmentTemp": "20-25",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "eSUN Red Wax Rapid",
      "link": "https://amzn.to/45bPyM7",
      "colors": [
        "#c7734a  |Red Wax"
      ],
      "description": "high-precision resin known for its ability to capture fine details.  It's ideal for printing intricate models and cosplay parts due to its good balance of hardness and toughness.",
      "price": "12.99",
      "tensileStrength": "36-52",
      "flexureStrength": "9-70",
      "elongationAtBreak": "10-20",
      "impactResistance": "",
      "hardness": "84",
      "uvWavelength": "355-410",
      "density": "1.05-1.25",
      "viscosity": "150-250",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1882-2385",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "80",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "FormLabs",
      "link": "https://formlabs.com/store/materials/precision-model-resin/",
      "colors": [
        "#f0c2ab  |Beige"
      ],
      "description": "Most accurate material for printing high-quality restorative models. It ensures over 99% of the printed surface area is within 100 μm of the digital model. This high-accuracy resin creates beautiful models with crisp margin lines, thanks to its high opacity, beige color, and smooth, matte finish, which captures fine details.",
      "price": "129",
      "tensileStrength": "50",
      "flexureStrength": "87",
      "elongationAtBreak": "8.6",
      "impactResistance": "32",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "2300",
      "youngsModulus": "2200",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "53.5",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "FormLabs Black Resin V5",
      "link": "https://formlabs.com/store/materials/black-resin/",
      "colors": [
        "#000000  |Black"
      ],
      "description": "Deep black General Purpose Resin, balancing fast print speed, high accuracy, a presentation-ready appearance, strong mechanical properties, and a reliable workflow. It creates stiff, strong parts with a surface finish rivaling injection molding, accurately capturing fine features with its rich, matte shade. The new Black Resin V5 formulation for the Form 4 Series prints three times faster than the previous version, with enhanced mechanical properties.",
      "price": "99",
      "tensileStrength": "57-61",
      "flexureStrength": "91-103",
      "elongationAtBreak": "10-14",
      "impactResistance": "29",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "2450-2750",
      "youngsModulus": "2450-2700",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "61-69",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "FormLabs Flame Retardant Resin",
      "link": "https://formlabs.com/store/materials/flame-retardant-resin/",
      "colors": [
        "#bbc0cc  |Grey"
      ],
      "description": "A UL 94 Blue Card-certified material designed for creating self-extinguishing, halogen-free parts with favorable flame, smoke, and toxicity (FST) ratings. It enables easy 3D printing of flame retardant, heat-resistant, stiff, and creep-resistant parts suitable for long-term use in indoor and industrial environments with high temperatures or ignition sources. It meets several tests and certifications, including UL 94 V-0 at 3 mm thickness for flammability, FAR 25.853 Appendix F, Part I for flammability, and ASTM E662 for FST.",
      "price": "249",
      "tensileStrength": "38.5-41.2",
      "flexureStrength": "72-75",
      "elongationAtBreak": "7.1-9.4",
      "impactResistance": "22.1-22.4",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "2900-3100",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "94-111",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "FormLabs Clear",
      "link": "https://formlabs.com/store/materials/clear-resin/",
      "colors": [
        "#ffe     |Clear"
      ],
      "description": "Color-neutral that balances fast print speed, high accuracy, transparency, strong mechanical properties, and an easy workflow. It produces highly transparent, colorless parts that can be polished to near optical transparency, with a smooth surface finish rivaling acrylic. The new Clear Resin V5 formulation, designed for the Form 4 ecosystem, prints three times faster than the previous version and offers improved clarity, color, and mechanical properties.",
      "price": "99",
      "tensileStrength": "51-60",
      "flexureStrength": "92-105",
      "elongationAtBreak": "8-10",
      "impactResistance": "29",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "2450-2700",
      "youngsModulus": "2575-2750",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "56-74",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "FormLabs Color Base",
      "link": "https://formlabs.com/store/materials/color-base-resin/",
      "colors": [
        "#f0c2ab  |Beige",
        "#000000  |Black",
        "#67c4de  |Blue",
        "#1d2228  |Dark Grey",
        "#79d9e0  |Emerald Blue",
        "#32383d  |Graphite",
        "#40bb7a  |Green",
        "#bbc0cc  |Grey",
        "#ece388  |Lemon Yellow",
        "#f0c2ac  |Light Beige",
        "#72362a  |Mahogany",
        "#8c6745  |Maple",
        "#b14a41  |Maroon",
        "#5f649b  |Medium Slate BLue",
        "#46cfb1  |Mint Green",
        "#f9925d  |Orange",
        "#906297  |Orchid",
        "#8640a9  |Purple",
        "#f8e3c2  |Skin",
        "#90daed  |Sky Blue",
        "#674c5f  |Slate BLue",
        "#1d263f  |Smokey black",
        "#cabeee  |Taro Purple",
        "#503a35  |Walnut",
        "#fff     |White",
        "#fcc262  |Yellow"
      ],
      "description": "Color Kit https://formlabs.com/store/materials/color-kit is the first integrated color mixing solution for resin 3D printing, allowing for a range of colors without manual finishing, dyeing, or painting. The Color Base Resin serves as the foundation for mixing with any Color Kit pigment to create Color Resin. Restock on Color Base Resin to mix with any Color Kit pigment and produce custom Color Resin.",
      "price": "119",
      "tensileStrength": "65",
      "flexureStrength": "",
      "elongationAtBreak": "6",
      "impactResistance": "25",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "2200",
      "youngsModulus": "2800",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "73",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Liqcreate Flame Retardant HDT",
      "link": "https://www.matterhackers.com/store/l/liqcreate-resin-for-lcd-dlp-3d-printers-flame-retardant-hdt",
      "colors": [
        "#fff     |White"
      ],
      "description": "Heat-resistant and compatible with DLP, LCD/MSLA, and laser-based systems. It has a high deflection temperature of up to 257°C and meets UL94 V0 fire safety standards, making it suitable for car interiors, railway, aviation, electronics, and manufacturing aids. Note that it adheres strongly to build plates.",
      "price": "60",
      "tensileStrength": "41-43",
      "flexureStrength": "67-73",
      "elongationAtBreak": "1-3",
      "impactResistance": "13",
      "hardness": "88-89",
      "uvWavelength": "",
      "density": "1.12",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "4300-4400",
      "youngsModulus": "4200",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "237-257",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Creality Plant-Based",
      "link": "https://amzn.to/3RajsKQ",
      "colors": [
        "#fefad7  |Cream Beige",
        "#46cfb1  |Mint Green",
        "#f9925d  |Orange",
        "#90daed  |Sky Blue"
      ],
      "description": "Ensures high precision and low shrinkage during the photocuring process, resulting in stable, smooth, and high-quality print models. The resin provides a unique combination of rigidity and toughness, offering excellent molding, impact resistance, and flexibility for durable models. It produces bright, soft colors using high-quality pigments and synthetic PLA oligomer, creating eye-catching models with a stunning color effect.",
      "price": "9.99",
      "tensileStrength": "58",
      "flexureStrength": "97",
      "elongationAtBreak": "10",
      "impactResistance": "84.36",
      "hardness": "",
      "uvWavelength": "",
      "density": "1.05-1.1",
      "viscosity": "340",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "1830",
      "youngsModulus": "875",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "82",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "eSUN Water Washable",
      "link": "https://amzn.to/3Rd2Wtu",
      "colors": [
        "#000000  |Black",
        "#fff     |White"
      ],
      "description": "Low viscosity, low odor, and can be easily cleaned with water. It cures quickly, improving printing efficiency and success rates, and is compatible with most LCD 3D printers. It contains acrylate monomers to reduce volume shrinkage during photocuring, ensuring high precision and a smooth finish. The resin has excellent fluidity, quickly infiltrating models to improve print speed and shorten curing time, with a good balance of hardness and toughness. Designed for LED light sources, it produces prints with vibrant, pure colors.",
      "price": "14.99",
      "tensileStrength": "68",
      "flexureStrength": "45-70",
      "elongationAtBreak": "5-10",
      "impactResistance": "18-39",
      "hardness": "76",
      "uvWavelength": "395-410",
      "density": "1.05-1.25",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "900-1400",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Form Futura Engineering Heavy Duty",
      "link": "https://formfutura.com/product/engineering-sla-series-heavy-duty-resin/",
      "colors": [
        "#bbc0cc  |Grey"
      ],
      "description": "Impressive flexural strength with high-temperature resistance and durability.",
      "price": "103.25",
      "tensileStrength": "91",
      "flexureStrength": "135",
      "elongationAtBreak": "8",
      "impactResistance": "20",
      "hardness": "87",
      "uvWavelength": "",
      "density": "1.12",
      "viscosity": "550",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "3250",
      "youngsModulus": "2500",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "Jayo Standard",
      "link": "https://amzn.to/3SR9a3d",
      "colors": [
        "#1d2228  |Dark Grey",
        "#bbc0cc  |Grey"
      ],
      "description": "aA fast-curing, high-precision 405nm photopolymer resin with low shrinkage for LCD/DLP/SLA printers. It is compatible with 4K/8K printers. Designed for easy use and high-quality 3D printing results.",
      "price": "23.99",
      "tensileStrength": "20-40",
      "flexureStrength": "25-45",
      "elongationAtBreak": "5-15",
      "impactResistance": "",
      "hardness": "80-85",
      "uvWavelength": "",
      "density": "",
      "viscosity": "100-350",
      "shrinkage": "7-9",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "650-900",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "JAYO ABS-Like",
      "link": "https://jayo3d.com/collections/resin/products/jayo-abs-like-resin-1kg-3d-printing-photopolymer-resin",
      "colors": [
        "#bbc0cc  |Grey"
      ],
      "description": "",
      "price": "26.99",
      "tensileStrength": "20-40",
      "flexureStrength": "",
      "elongationAtBreak": "15-25",
      "impactResistance": "",
      "hardness": "70-80",
      "uvWavelength": "395-405",
      "density": "1.04-1.14",
      "viscosity": "200-400",
      "shrinkage": "6-8",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "600-800",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "JAYO Standard PLUS",
      "link": "https://jayo3d.com/collections/resin/products/jayo-standard-plus-resin-1kg-3d-printing-photopolymer-resin",
      "colors": [
        "#1d2228  |Dark Grey",
        "#bbc0cc  |Grey"
      ],
      "description": "",
      "price": "25.99",
      "tensileStrength": "",
      "flexureStrength": "",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "JAYO Water Washable",
      "link": "https://jayo3d.com/collections/resin/products/jayo-water-washable-resin-1kg-3d-printing-photopolymer-resin",
      "colors": [
        "#f0c2ab  |Beige",
        "#000000  |Black",
        "#1d2228  |Dark Grey",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "",
      "price": "28.99",
      "tensileStrength": "35-55",
      "flexureStrength": "",
      "elongationAtBreak": "8-14",
      "impactResistance": "",
      "hardness": "80-85",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "6-8",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "800-1100",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "JAYO Plant-Based",
      "link": "https://jayo3d.com/collections/resin/products/jayo-plant-based-resin-1kg-3d-printing-photopolymer-resin",
      "colors": [
        "#f0c2ab  |Beige",
        "#000000  |Black",
        "#ffe     |Clear",
        "#1d2228  |Dark Grey"
      ],
      "description": "",
      "price": "27.99",
      "tensileStrength": "20-35",
      "flexureStrength": "",
      "elongationAtBreak": "5-12",
      "impactResistance": "",
      "hardness": "80-85",
      "uvWavelength": "395-405",
      "density": "",
      "viscosity": "",
      "shrinkage": "7-9",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "600-800",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "JAYO PA-Like (Nylon-Like)",
      "link": "https://jayo3d.com/collections/resin/products/jayo-pa-like-resin-1kg-3d-printing-photopolymer-resin",
      "colors": [
        "#000000  |Black",
        "#1d2228  |Dark Grey",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "Here is where I found out about this resin. Thank you Cristie-c and reddit! https://www.reddit.com/r/resinprinting/comments/1eutyul",
      "price": "39.99",
      "tensileStrength": "20-50",
      "flexureStrength": "",
      "elongationAtBreak": "20-50",
      "impactResistance": "",
      "hardness": "70-80",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "6-8",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "650-900",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    },
    {
      "name": "JAYO Water Washable ABS-Like",
      "link": "https://amzn.to/4fUexs7",
      "colors": [
        "#000000  |Black",
        "#1d2228  |Dark Grey",
        "#bbc0cc  |Grey",
        "#fff     |White"
      ],
      "description": "A 3D printer resin designed for LCD/DLP/SLA 3D printers. Water washable, ABS-like properties, Low shrinkage and high precision, Fast curing with low odor, Compatible with most 2K/4K/6K/8K LCD DLP SLA 3D printers.",
      "price": "",
      "tensileStrength": "",
      "flexureStrength": "",
      "elongationAtBreak": "",
      "impactResistance": "",
      "hardness": "",
      "uvWavelength": "",
      "density": "",
      "viscosity": "",
      "shrinkage": "",
      "printingEnvironmentTemp": "",
      "flexuralModulus": "",
      "youngsModulus": "",
      "flexuralStrainAtBreak": "",
      "flexuralStressAtMax": "",
      "hdt": "",
      "heatCapacity": "",
      "curingTemp": ""
    }
  ]
};